export enum Features {
  FEATURE_ASSETS = 'feature-assets',
  FEATURE_ZONES = 'feature-zones',
  FEATURE_CATEGORIES = 'feature-categories',
  FEATURE_RENT = 'feature-rent',
  FEATURE_CONTRACTORS = 'feature-contractors',
  FEATURE_CONTRACTOR_AVAILABILITY = 'feature-contractor-availability',
  FEATURE_CONTRACTOR_PROXIMITY = 'feature-contractor-proximity',
  FEATURE_ISSUES = 'feature-issues',
  FEATURE_WORK_ORDERS = 'feature-work-orders',
  FEATURE_WORK_AVAILABILITY = 'feature-work-availability',
  FEATURE_ORDERS = 'feature-orders',
  FEATURE_ORDER_ASSET = 'feature-order-asset',
  FEATURE_ORDER_TEMPLATES = 'feature-order-templates',
  FEATURE_QR_CODES = 'feature-qr-codes',
  FEATURE_CALENDAR = 'feature-calendar',
  FEATURE_TIMESHEET = 'feature-timesheet',
  FEATURE_QUALITY_CHECK = 'feature-quality-check',
  FEATURE_WORK_OFFERS = 'feature-work-offers',
  FEATURE_WORKFLOWS = 'feature-workflows',
  FEATURE_REPORTS = 'feature-reports',
  FEATURE_ASSET_HIERARCHY = 'feature-asset-hierarchy',
  FEATURE_HIDE_WORK_ADVANCED_FILTERS = 'feature-hide-work-advanced-filters',
}

export interface FeatureConfig {
  key: Features;
  name: string;
}

export type FeatureAccessMap = Record<Features, boolean>;

export interface FeatureAccessState {
  isTenantReady: boolean;
  access: FeatureAccessMap;
}
